import type {StoreGeneric} from 'pinia';

export const storeMap = new Map<string, StoreGeneric>();
export default ({store}: any) => {
  storeMap.set(store.$id, store);
};
